<!-- eslint-disable vuejs-accessibility/mouse-events-have-key-events -->
<template>
  <div class="content-view container py-3">
    <h2 class="w-100 fw-600 text-start mt-5">
      Sua solicitação foi enviada com sucesso!
    </h2>

    <div class="row mt-5">
      <div class="col-12 col-lg-6">
        <div class="what-now-container mb-4 p-4">
          <h3 class="what-now-title text-start mb-4">
            O que vai acontecer agora?
          </h3>

          <div
            v-for="message in selectedMessages"
            :key="message"
            class="d-flex align-items-start mb-2"
          >
            <Icon
              class="icon pe-2"
              name="circle-check"
              style="color: var(--color-success)"
            />

            <p class="fs-6 text-start" v-html="message"></p>
          </div>
        </div>

        <div class="check-process-container p-4">
          <h3 class="check-process-title text-start mb-4">
            Enquanto isso você pode consultar o andamento da sua solicitação.
          </h3>

          <div>
            <p class="fs-6 text-start">
              Código da solicitação:
              <strong>{{ solicitationCode }}&nbsp;&nbsp;</strong>
              <Icon
                id="copy-solicitation-code-icon"
                name="copy"
                @click="copyToClipboard(solicitationCode)"
                @mouseleave="resetContent"
              />
            </p>
          </div>

          <div class="d-flex">
            <button
              type="button"
              class="btn btn-primary btn-sm"
              @click="openNewTab"
            >
              <span class="me-2">Consultar andamento</span>
              <Icon name="magnifying-glass" />
            </button>
          </div>
        </div>
      </div>

      <div class="d-none d-lg-block col-6 d-flex justify-content-center">
        <img
          id="validation-success-image"
          src="@/assets/images/success-view.svg"
          alt="domain-validation"
        />
      </div>
    </div>

    <Contact />
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import Contact from '@/components/Molecules/Contact.vue'
  import Icon from '@/components/Atoms/Icon.vue'
  import { Tooltip } from 'bootstrap'
  import { mapState } from 'pinia'
  import { useSolicitation } from '@/store/Pinia/useSolicitation.store'
  import { useAR } from '@/store/Pinia/useAR.store'

  export default defineComponent({
    components: {
      Contact,
      Icon,
    },
    data: () => ({
      solicitationCode: '',
      copyToClipboardTooltip: null as Tooltip | null,
      messages: [
        {
          type: 'feedback-http-email-dns-ontime-wo-qsa',
          messages: [
            'Agora um de nossos Agentes fará a <strong>análise dos documentos.</strong>',
            'Assim que estiver tudo certo, você <strong>receberá as instruções para os próximos passos no seu e-mail.</strong>',
          ],
        },
        {
          type: 'feedback-http-dns-later-w-qsa',
          messages: [
            'Assim que você concluir a <strong>validação do seu domínio</strong> e estiver tudo certo, você <strong>receberá as instruções para os próximos passos no seu e-mail.</strong>',
          ],
        },
        {
          type: 'feedback-http-dns-later-wo-qsa',
          messages: [
            'Agora um de nossos Agentes fará a <strong>análise dos documentos.</strong>',
            'Enquanto isso,  estaremos aguardando a propagação do DNS com a <strong>validação do seu domínio.</strong> Você poderá consultar o andamento da validação <strong>através do e-mail que enviamos pra você.</strong>',
            'Assim estiver tudo certo, você <strong>receberá as instruções para os próximos passos no seu e-mail.</strong>',
          ],
        },
        {
          type: 'feedback-dns-later-wo-qsa',
          messages: [
            'Agora um de nossos Agentes fará a <strong>análise dos documentos.</strong>',
            'Você também precisará concluir a <strong>validação do seu domínio.</strong>',
            'Assim estiver tudo certo, você <strong>receberá as instruções para os próximos passos no seu e-mail.</strong>',
          ],
        },
      ],
    }),
    computed: {
      ...mapState(useSolicitation, ['getSolicitation']),
      ...mapState(useAR, ['arData']),
      selectedMessages(): string[] {
        // eslint-disable-next-line max-len
        return (
          this.messages.find(
            (message) => message.type === this.$route.params.type,
          )?.messages || []
        )
      },
    },
    mounted() {
      this.copyToClipboardTooltip = new Tooltip(
        '#copy-solicitation-code-icon',
        {
          title: 'Clique para copiar',
          placement: 'right',
        },
      )

      this.solicitationCode = this.getSolicitation.cdSolicitacao
    },
    methods: {
      copyToClipboard(content: string) {
        navigator.clipboard.writeText(content)
        this.copyToClipboardTooltip?.setContent({
          '.tooltip-inner': 'Código copiado!',
        })
      },
      resetContent() {
        this.copyToClipboardTooltip?.setContent({
          '.tooltip-inner': 'Clique para copiar',
        })
      },
      openNewTab() {
        window.open(
          `https://${
            this.arData.subdomain || ''
          }.acsoluti.com.br/site/verificar-situacao-de-emissao`,
          '_blank',
        )
      },
    },
    beforeRouteEnter(to, from, next) {
      const solicitationStore = useSolicitation()
      if (solicitationStore.getSolicitation.cdSolicitacao === '') {
        return next('/')
      }
      return next()
    },
  })
</script>

<style scoped>
  .content-view {
    height: 100%;
  }

  .what-now-container {
    background: #f0f0f3;
    border-radius: 15px;
  }

  .what-now-title {
    color: #5500af;
  }

  .check-process-container {
    border: 1px solid #83848f;
    border-radius: 15px;
  }

  .check-process-title {
    font-weight: 400;
    font-size: 20px;
    line-height: 30px;
  }

  #validation-success-image {
    width: auto;
    height: 380px;
  }

  #copy-solicitation-code-icon {
    cursor: pointer;
  }
</style>
